import { render } from "./CIS-Latest-Spotlight.vue?vue&type=template&id=74c03736&scoped=true"
import script from "./CIS-Latest-Spotlight.vue?vue&type=script&lang=js"
export * from "./CIS-Latest-Spotlight.vue?vue&type=script&lang=js"

import "./CIS-Latest-Spotlight.vue?vue&type=style&index=0&id=74c03736&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c03736"]])

export default __exports__